<template>
    <div>
        <v-data-table v-if="items.length > 0" :items="items" :headers="headers">
            <template v-slot:item="props">
                <tr>
                    <td v-for="(header, index) in headers"
                        :key="index"
                        :class="all(props.index) ? 'red lighten-1' : propRequired(header.value,props.index)">
                        <span>{{ props.item[header.value] }}</span>
                    </td>
                </tr>
            </template>
        </v-data-table>
    </div>
</template>
<script>
    export default {
        props: {
            items: {
                default: () => [],
                type: Array
            },
            properties: {
                default: () => [],
                type: Array
            }
        },
        data: () => ({
            headers: [
                {
                    text: "EmpCode",
                    value: "empCode",
                    sortable: false
                },
                {
                    text: "Company",
                    value: "company",
                    sortable: false
                },
                {
                    text: "Nature",
                    value: "nature",
                    sortable: false
                },
                {
                    text: "TIN",
                    value: "tin",
                    sortable: false
                },
                {
                    text: "Address",
                    value: "address",
                    sortable: false
                },
                /*RLV:30Jun2022*/
                {
                    text: "Country",
                    value: "countryCode",
                    sortable: false
                },
                {
                    text: "TelNo",
                    value: "telNo",
                    sortable: false
                },
                {
                    text: "Designation Code",
                    value: "desCode",
                    sortable: false
                },
                /*RLV:30Jun2022*/
                {
                    text: "Work Contract",
                    value: "workCode",
                    sortable: false
                },
                {
                    text: "Project",
                    value: "project",
                    sortable: false
                },
                {
                    text: "Duties and Responsibilities Code",
                    value: "dutiesResponsibilitiesCode",
                    sortable: false
                },
                {
                    text: "Date Start",
                    value: "dateStart",
                    sortable: false
                },
                {
                    text: "Date End",
                    value: "dateEnd",
                    sortable: false
                },
                {
                    text: "Salary Start",
                    value: "salaryStart",
                    sortable: false
                },
                {
                    text: "Salary End",
                    value: "salaryEnd",
                    sortable: false
                },
                {
                    text: "Superior",
                    value: "superior",
                    sortable: false
                },
                {
                    text: "Ref",
                    value: "ref",
                    sortable: false
                },
                /*RLV:30Jun2022*/
                {
                    text: "For 2316",
                    value: "isFor2316",
                    sortable: false
                }
            ]
        }),
        computed: {},
        methods: {
            propRequired(prop, index) {
                var result = this.properties.filter(item => {
                    return (
                        item.property.toLowerCase() == prop.toLowerCase() &&
                        item.index == index &&
                        item.mode == "PREVEMP"
                    );
                });

                if (result.length > 0) return "red lighten-1";
                else return "";
            },
            all(index) {
                var result = this.properties.filter(item => {
                    return (
                        item.property == "ALL" &&
                        item.mode == "PREVEMP" &&
                        item.index == index
                    );
                });
                if (result.length > 0) return true;
                else false;
            }
        }
    };
</script>